import { Button, Divider, Flex, Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Stack, Text } from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';
import {
  RiArrowRightLine,
  RiMap2Line,
  RiPhoneLine,
  RiProfileLine,
  RiUser3Line,
} from 'react-icons/ri';

type SortData = {
	por: string;
	cres: boolean;
};
type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};
type VendaData = {
	agendamento: boolean;
	campanha: string;
	cupom: { id_desconto: string; type_desc: string; valor: string };
	distance: number;
	duration: number;
	endereco_entrega: EnderecoData;
	formatted_address: string;
	hora_agendada: string;
	cliente: {
		id: string;
		nome: string;
		doc: string;
		phone: string;
		cid: string;
	};
	id_order: number;
	items: ItemData[];
	merchant_id: number;
	mesa: boolean;
	mesa_number: string;
	mesa_token: string;
	order_data: string;
	order_status: string;
	pagamentos: PagamentoData[];
	prev_entrega: string;
	retirar: boolean;
	subTotal: number;
	taxa_entrega: number;
	taxa_service: number;
	tempo_preparo: number;
	tempo_preparo_str: string;
	total: number;
	totalFormatted: string;
	total_merchant: number;
}
type EnderecoData = {
	bai: string;
	cep: string;
	cid: string;
	cidcod: string;
	comp: string;
	distace: {
		distance: { value: number };
		duration: { value: number };
	};
	endereco: string;
	formatted_address: string;
	id: string;
	location: { lat: number; lng: number };
	num: string;
	ponto_ref: string;
	uf: string;
}
type PagamentoData = {
	band_pay: string;
	chave_pay: string;
	currency_pay: string;
	id_pay: number;
	method_pay: string;
	name_pay: string;
	tipchave_pay: string;
	trocoFormatted: string;
	troco_para: number;
	type_pay: string;
	url_pay: string;
}
type ItemData = {
	cod_barras: string;
	complementos: ComplementoData[];
	descricao: string;
	id: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	total: number;
	totalFormatted: string;
	url_imagem: string;
	valor: number;
	valorFormatted: string;
}
type ComplementoData = {
	codigo: string;
	descricao: string;
	grupo: string;
	nome: string;
	priceFormatted: string;
	qtd: number;
	qtd_gratis: number;
	qtd_maxima: number;
	valor: number;
}
interface DataTableCardsParams {
	vendas: VendaData[];
	pesqVendas: VendaData[];
	sort: SortData;
	setSort: (sort: SortData) => void;
	controls: ControlsData;
	handleUpdateList: (
		page: number,
		perPage: number,
		vendas: VendaData[],
	) => void;
	setVendaModal: (vendas: VendaData) => void;
	setModalVendaVisible: (visible: boolean) => void;
	setModalVendaCancelarVisible: (visible: boolean) => void;
}

const DataTableCards: React.FC<DataTableCardsParams> = ({
	vendas,
	pesqVendas,
	sort,
	setSort,
	controls,
	handleUpdateList,
	setVendaModal,
	setModalVendaVisible,
	setModalVendaCancelarVisible
}) => {
  return (
    <Flex w="100%" flexDir="column" justify="center" align="center">
      {vendas.map(venda => {
        return (
          <Flex
						key={venda.id_order}
            justify="space-between"
            w="100%"
            bgGradient="linear(to-r, gray.50, gray.100)"
            borderRadius={8}
            boxShadow="xl"
            p="4"
						pr="2"
						m={["2", "4"]}
          >
						<Flex w="100%">
							<Stack w="100%" spacing={1}>
                {venda.id_order && (
                  <Flex align="center">
                    <Text
                      color="gray.800"
                      fontWeight="500"
                    >
											{venda.id_order}
                    </Text>

										{venda.order_status && (
											<Text
												textTransform="uppercase"
												color={venda.order_status === 'CANCELADO'
													? '#b71c1c'
													: venda.order_status === 'CONCLUÍDO' || venda.order_status === 'CONFIRMADA' || venda.order_status === 'FINALIZADA'
														? '#1b5e20'
														: venda.order_status === 'COM ENTREGADOR' || venda.order_status === 'EM PREPARO'
															? '#1a83ff'
															: '#ff6f00'
												}
												fontWeight="bold"
											>
												&nbsp;- {venda.order_status}
											</Text>
										)}
                  </Flex>
                )}

								{venda.cliente && (
                  <Flex align="center">
										<Icon as={RiUser3Line} color="gray.600" fontSize="16" mr="1" />
                    <Text color="gray.600" fontSize="14" fontWeight="500">
											{venda.cliente.nome}
                    </Text>
                  </Flex>
                )}

								{venda.items && (
									<Flex align="center">
										<Text color="gray.500" fontSize="14" fontWeight="500">
											Items: {venda.items.length}
										</Text>
									</Flex>
								)}

								{venda.order_data && (
                  <Flex align="center">
										<Text color="gray.600" fontSize="14" fontWeight="500">
											Data: {venda.order_data}
                    </Text>
                  </Flex>
                )}

								<Flex w="100%" justify="space-between">
									{venda.totalFormatted && (
										<Flex align="center">
											<Text color="gray.600" fontSize="14" fontWeight="500">
												Vlr. Total: {venda.totalFormatted}
											</Text>
										</Flex>
									)}

									<Menu isLazy>
										{({ isOpen }) => (
											<>
												<MenuButton
													as={IconButton}
													fontSize={["1.6rem", "2rem"]}
													isActive={isOpen}
													icon={<FiMoreVertical />}
													_hover={{ bg: 'gray.50' }}
													_expanded={{ bg: 'gray.100' }}
													css={{ '-webkit-tap-highlight-color': 'transparent' }}
												/>

												<MenuList p={0} boxShadow='xl'>
													<MenuItem
														fontSize={16}
														fontWeight={500}
														py={3}
														_hover={{
															bg: 'gray.50'
														}}
														onClick={() => {
															setVendaModal(venda);
															setModalVendaVisible(true);
														}}
													>
														Detalhes
													</MenuItem>

													<Divider />

													<MenuItem
														fontSize={16}
														fontWeight={500}
														py={3}
														_hover={{
															bg: 'gray.50'
														}}
														onClick={() => {
															setVendaModal(venda);
															setModalVendaCancelarVisible(true);
														}}
														isDisabled={
															venda.order_status &&
																venda.order_status.toUpperCase() === 'CANCELADO'
																? true
																: false
														}
													>
														Cancelar
													</MenuItem>
												</MenuList>
											</>
										)}
									</Menu>
								</Flex>
              </Stack>
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default DataTableCards;
